import { render, staticRenderFns } from "./UnacceptedProductProcessOrder.vue?vue&type=template&id=991c5064&scoped=true&"
import script from "./UnacceptedProductProcessOrder.vue?vue&type=script&lang=js&"
export * from "./UnacceptedProductProcessOrder.vue?vue&type=script&lang=js&"
import style0 from "./UnacceptedProductProcessOrder.vue?vue&type=style&index=0&id=991c5064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991c5064",
  null
  
)

export default component.exports